import { type IntroductionHalf } from '@sunrise-ui/api/network';

export default function useIntroHalves({
  introHalves,
}: {
  introHalves: IntroductionHalf[];
}) {
  const requestor = introHalves?.find(
    (i) => i.introduced_to.intro_role === 'requestor',
  );
  const acceptor = introHalves?.find(
    (i) => i.introduced_to.intro_role === 'acceptor',
  );

  return { requestor, acceptor };
}
